export const GUEST_RESERVATION_COUNTDOWN_MINUTES = 15;
export const GUEST_RESERVATION_COUNTDOWN_SECONDS = GUEST_RESERVATION_COUNTDOWN_MINUTES * 60;
